const T_PREFIX = "inquiry-settings";

export const inquirySettingsTrns = {
  title: `${T_PREFIX}.title`,
  industry: `${T_PREFIX}.industry-field`,
  product: `${T_PREFIX}.product-field`,
  titleField: `${T_PREFIX}.title-field`,
  employees: `${T_PREFIX}.employees-field`,
  yearsOnTheMarket: `${T_PREFIX}.years-on-the-market-field`,
  customerCount: `${T_PREFIX}.customer-count-field`,
  annualTurnover: `${T_PREFIX}.annual-turnover-field`,
  monthlyIncome: `${T_PREFIX}.min-investment-field`,
  minInvestment: `${T_PREFIX}.investment-amount-field`,
  listPrice: `${T_PREFIX}.list-price-field`,
  description: `${T_PREFIX}.description-field`,
  cancelButton: `${T_PREFIX}.cancel-btn`,
  publishButton: `${T_PREFIX}.publish-btn`,
  changeInformationTitle: `${T_PREFIX}.edit.change-info.title`,
};

export const cloneTypeOptionsTrns = {
  company: `${T_PREFIX}.clone-type.company`,
  product: `${T_PREFIX}.clone-type.product`,
  service: `${T_PREFIX}.clone-type.service`,
};
